import type { SectionFieldType } from '@Types/GF/Fields';

type Props = {
	field: SectionFieldType;
};

export default function SectionField({ field }: Props) {
	const { type, cssClass, label, description } = field;

	return (
		<div className={`mb-5 mt-5 first:mt-0 last:mb-0 gfield gfield-${type} ${cssClass}`.trim()}>
			<h3 className='text-2xl'>{label}</h3>
			<hr className='mb-1 mt-2 border-minos-form-secondary-color' />
			<div>{description}</div>
		</div>
	);
}
